<template>
  <v-dialog v-model="opened" :transition="false" :max-width="800" :persistent="false">
    <!-- @click:outside="!$async.---.$pending ? close() : () => {}" -->
    <v-card>
      <v-card-title class="headline"></v-card-title>
      <v-card-text>
        <FormEventSchedules
          ref="formEventSchedulesForm"
          :eventId="eventId"
          :data="data"
          :idx="idx"
          :timezone="timezone"
          :is-only-edit="isOnlyEdit"
          @close="close"
          @change-event-schedules="$emit('change-event-schedules', $event)"
          @delete="$emit('delete-event-shedule', $event)"
        />
      </v-card-text>
    </v-card>
  </v-dialog>
</template>

<script>
import DialogAbstract from '@/components/abstract/dialog'
import FormEventSchedules from '@/components/event/schedules/form'

export default {
  extends: DialogAbstract,
  name: 'FormDialogEvent',
  props: {
    data: {
      type: Object,
      default: null
    },
    eventId: {
      type: Number,
      default: null
    },
    idx: {
      type: Number,
      default: null
    },
    timezone: {
      type: String,
      default: 'Europe/Moscow'
    },
    isOnlyEdit: {
      type: Boolean,
      default: false
    }
  },
  components: {
    FormEventSchedules
  },
  methods: {
    close () {
      if (this.$refs?.formEventSchedulesForm?.closeDialog) {
        this.$refs.formEventSchedulesForm.closeDialog()
        this.opened = false
      }
    },
    open (isNew = false) {
      this.opened = true
      if (this.$refs.formEventSchedulesForm && !isNew) {
        this.$refs.formEventSchedulesForm.openDialog()
      }
    }
  }
}
</script>
